import React, { useState } from 'react';
import '../styles/components/ChatAssistant.scss';
import icon from '../assets/icon.png';

interface ChatAssistantProps {
    pageContent: string;
}

const ChatAssistant: React.FC<ChatAssistantProps> = ({ pageContent }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [userPrompt, setUserPrompt] = useState('');
    const [analysisResult, setAnalysisResult] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [copied, setCopied] = useState(false);

    const toggleChat = () => {
        setIsOpen(!isOpen);
    };

    const handleAnalyze = async () => {
        if (!userPrompt.trim()) {
            setAnalysisResult('Please enter a prompt or question.');
            return;
        }

        try {
            setIsLoading(true);

            const bodyData = {
                content: pageContent,
                user_prompt: userPrompt,
            };

            const resp = await fetch(
                'https://seeker-ai-app-3e2faf8ed0d7.herokuapp.com/api/analyze',
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(bodyData),
                }
            );

            const data = await resp.json();
            if (data.summary) {
                setAnalysisResult(data.summary);
            } else if (data.error) {
                setAnalysisResult('Error: ' + data.error);
            }
        } catch (error) {
            console.error(error);
            setAnalysisResult('An error occurred calling the API.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCopy = () => {
        if (!analysisResult) return;
        navigator.clipboard
            .writeText(analysisResult)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            })
            .catch((err) => console.error('Failed to copy text:', err));
    };

    return (
        <div className={`chat-assistant ${isOpen ? 'open' : ''}`} style={{ display: 'none' }}>
            <div className="chat-header" onClick={toggleChat}>
                <img src={icon} alt="AI Assistant" className="chat-icon" />
            </div>
            {isOpen && (
                <div className="chat-body">
                    <textarea
                        placeholder="Type your prompt or question..."
                        value={userPrompt}
                        onChange={(e) => setUserPrompt(e.target.value)}
                        className="prompt-input"
                    />
                    {!isLoading && (
                        <button onClick={handleAnalyze} className="analyze-button">
                            Analyze with AI
                        </button>
                    )}
                    {isLoading && (
                        <div className="spinner-container">
                            <div className="loading-spinner"></div>
                            <p className="spinner-text">Analyzing, please wait...</p>
                        </div>
                    )}
                    <p className="response-label">AI Response:</p>
                    <textarea
                        value={analysisResult}
                        readOnly
                        onClick={handleCopy}
                        title="Click to copy"
                        className="response-output"
                    />
                    {copied && <p className="copied-notification">Copied!</p>}
                </div>
            )}
        </div>
    );
};

export default ChatAssistant;